<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col
      md="12"
      class="pa-3 d-flex flex-column"

      v-if="this.condition()"
  >
    <a class="anchor" id="blocalimconfiance"></a>
    <v-card elevation="2">
      <v-card-title>Contrôles Sanitaires de l'établissement</v-card-title>
      <v-card-text>
        <a href="https://www.alim-confiance.gouv.fr/" target="_blank">
          <img
              title="Etablissement ayant été contrôlé"
              src="../../assets/logo_alim_confiance.png"
          />
        </a>

        <v-data-table
            v-if="this.alim_inspections != null"
            dense
            :headers="headers"
            :items="alim_inspections"
            item-key="numero_inspection"
            class="elevation-1"
        >
          <template v-slot:item.alerte="{ item }">
            <v-icon v-if="item.alerte==1" color="red">
              mdi-alert-circle
            </v-icon>
          </template>
          <template
              v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
              v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:item.synthese_eval_sanit="{ item }">
            <v-chip
                :color="formatInspection(item.synthese_eval_sanit)"
                dark
            >
              {{ item.synthese_eval_sanit }}
            </v-chip>
          </template>

        </v-data-table>

      </v-card-text>


      <v-card-title v-if="this.alim_inspections_etablissements != null">Contrôles Sanitaires des autres établissements
      </v-card-title>
      <v-card-text v-if="this.alim_inspections_etablissements != null">
        <a href="https://www.alim-confiance.gouv.fr/" target="_blank">
          <img
              title="Etablissement ayant été contrôlé"
              src="../../assets/logo_alim_confiance.png"
          />
        </a>

        <v-data-table
            v-if="this.alim_inspections_etablissements != null"
            dense
            :headers="headers"
            :items="alim_inspections_etablissements"
            item-key="numero_inspection"
            class="elevation-1"
        >
          <template v-slot:item.alerte="{ item }">
            <v-icon v-if="item.alerte==1" color="red">
              mdi-alert-circle
            </v-icon>
          </template>
          <template
              v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
              v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>
          <template v-slot:item.synthese_eval_sanit="{ item }">
            <v-chip
                :color="formatInspection(item.synthese_eval_sanit)"
                dark
            >
              {{ item.synthese_eval_sanit }}
            </v-chip>
          </template>
          <template #item.siret="{ item }"><a @click="displaySelected(item.siret)">
            <v-icon x-small v-if="item.siret!=''">mdi-open-in-new</v-icon>
            {{ item.siret ? item.siret : "" }}</a></template>
        </v-data-table>

      </v-card-text>

    </v-card>
  </v-col>
</template>

<script>

export default {
  name: "Alimconfiance",
  props: [""],
  components: {},
  data: () => ({
    search: '',
    filter: {},
    sortDesc: false,
    page: 1,
    itemsPerPage: 10,
  }),
  computed: {
    alim_inspections: function () {
      var listeControles = this.$store.getters.getbloc("certificats", "donnees", "alimconfiance_inspection", null, "valeur")
      if (listeControles == null || listeControles.length == 0)
        return null // ne pas retourner la liste des autres etabs si & seul déjà mentionné dans certif_qualite_tourisme
      else
        return listeControles
    },
    alim_inspections_etablissements: function () {
      var listeControles = this.$store.getters.getbloc("certificats", "donnees", "alimconfiance_inspection_etablissements", null, "valeur")
      if (listeControles == null || listeControles != null && listeControles.length == 1)
        return null // ne pas retourner la liste des autres etabs si & seul déjà mentionné dans certif_qualite_tourisme
      else

        return listeControles
    },

    headers() {
      return [
        {
          text: "",
          align: "start",
          value: "alerte",
          fixed: true,
          width: "10px",
        },
        {
          text: "Numero",
          align: "start",
          value: "numero_inspection",
          fixed: true,
          width: "10px",
        },
        {
          text: "Date",
          value: "date_inspection",
          align: "start",
          fixed: true,
          width: "100px",
          formatter: this.formatDate,
        },

        {
          text: "Evaluation",
          value: "synthese_eval_sanit",
          align: "start",
          fixed: true,
          width: "100px",
        },

        {
          text: "Activité",
          value: "app_libelle_activite_etablissement",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Siret",
          value: "siret",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Nom",
          value: "app_libelle_etablissement",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Rue",
          value: "adresse_2_ua",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "CP",
          value: "code_postal",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Ville",
          value: "libelle_commune",
          align: "start",
          fixed: true,
          width: "100px",
        },

      ];
    },
  },

  methods: {
    displaySelected(siret) {
      this.$store.dispatch('getEtablissement', siret)
    },
    condition() {
      return this.$store.getters.condition("certificats", "donnees", "alimconfiance_inspection", "valeur");
    },
    formatDate(value) {
      if (value && value.length > 8) {
        return new Date(Date.parse(value)).toLocaleDateString();
      } else {
        return value;
      }
    },
    formatInspection(value) {

      switch (value) {
        case 'A améliorer':
          return "yellow"
        case 'Très satisfaisant':
          return "green"
        case 'Satisfaisant':
          return "blue"
        case 'A corriger de manière urgente':
          return "red"
        default:
          return ""
      }


    },
  },

};
</script>
